import PromoCounter from "./PromoCounter";
export default PromoCounter